import { useRef, forwardRef, useImperativeHandle, useState } from 'react';
import { Popover } from 'antd';
import styles from './infinitecanvas.module.css';

export const InfiniteCanvas = forwardRef((props, ref) => {
    const { children, className, showCoords = true } = props;
    const dragStart = useRef(null);
    const holder = useRef(null);
    const container = useRef(null);
    const holderStart = useRef(null);
    const adder = useRef(null);
    const isDragging = useRef(false);
    useImperativeHandle(ref, () => ({
        moveTo: (x, y) => {
            holder.current.classList.add(styles.withanim);
            holder.current.style.top = `${(document.body.clientHeight / 2) - y}px`;
            holder.current.style.left = `${((document.body.clientWidth - 400) / 2) - x}px`;
            setTimeout(() => {
                holder.current.classList.remove(styles.withanim);
            }, 500);
        }
    }));
    return <div className={`${styles.container} ${className}`} ref={container} onMouseDown={e => {
        e.preventDefault();
        dragStart.current = { x: e.clientX, y: e.clientY };
        holderStart.current = { top: holder.current.offsetTop, left: holder.current.offsetLeft };
    }} onMouseMove={e => {
        if (dragStart.current) {
            // e.preventDefault();
            isDragging.current = true;
            holder.current.style.top = `${holderStart.current.top + e.clientY - dragStart.current.y}px`;
            holder.current.style.left = `${holderStart.current.left + e.clientX - dragStart.current.x}px`;
            container.current.style.cursor = 'move';
        }
        if(showCoords)
            document.querySelector(`.${styles.coords}`).innerHTML = `${e.clientX - holder.current.offsetLeft}, ${e.clientY - holder.current.offsetTop}`;
    }} onMouseUp={e => {
        e.preventDefault();
        dragStart.current = null;
        holderStart.current = null;
        isDragging.current = false;
        container.current.style.cursor = null;
    }}>
        <div className={styles.holder} ref={holder}>
            {children}
        </div>
        {showCoords &&  <div className={styles.coords}></div>}
    </div>
});